import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatNumber,
  localizeLeaveType,
  useSpot
} from 'framework';
import {
  Row,
  Container,
  FormTextInput,
  FormLabel,
  FormRow,
  Line
} from 'components';

export function LeaveRemaining({
  id,
  organization
}: {
  id: string;
  organization: string;
}) {
  const { t } = useTranslation();
  const { data, query } = useSpot();

  const user = data?.users?.[id];
  const org = data?.organizations?.[organization];
  const shouldLookupOrg = !data?.organizations?.[organization];
  const disabledLeaveTypes = org?.disabledLeaveTypes ?? [];
  const nonDeductibleLeaveTypes = org?.nonDeductibleLeaveTypes ?? [];

  useEffect(() => {
    (async () => {
      if (shouldLookupOrg) {
        await query(`org/${organization}`, {}, ['organizations', organization]);
      }
      await query(`org/${organization}/user/${id}`, {}, ['users', id]);
    })();
  }, [query, organization, id, shouldLookupOrg]);

  return (
    <>
      <Line />
      <Row>
        <Container>
          {Object.entries(user?.leaveRemaining ?? {})
            .filter(
              ([type]) =>
                !disabledLeaveTypes.includes(type) &&
                !nonDeductibleLeaveTypes.includes(type)
            )
            .map(([type, amount]) => {
              const localizedType = localizeLeaveType(t, type);
              const allocation = user?.leaveAllocation?.[type];
              const showTotal = allocation !== undefined;
              const formattedAmount =
                amount === undefined
                  ? ''
                  : formatNumber(amount, { maximumFractionDigits: 2 });
              const formattedAllocation =
                allocation === undefined
                  ? ''
                  : formatNumber(allocation, { maximumFractionDigits: 2 });

              return (
                <FormRow key={type}>
                  <FormLabel>{localizedType}</FormLabel>
                  <FormTextInput
                    disabled
                    initialValue={`${formattedAmount} ${
                      showTotal ? `${t('of')} ${formattedAllocation}` : ''
                    }`}
                    endAdornment={t('days')}
                  />
                </FormRow>
              );
            })}
        </Container>
      </Row>
    </>
  );
}
